var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.0005C20 15.5233 15.5228 20.0005 10 20.0005C4.47715 20.0005 0 15.5233 0 10.0005C0 4.47764 4.47715 0.000488281 10 0.000488281C15.5228 0.000488281 20 4.47764 20 10.0005ZM7.70711 6.29338C7.31658 5.90286 6.68342 5.90286 6.29289 6.29338C5.90237 6.68391 5.90237 7.31707 6.29289 7.70759L8.58579 10.0005L6.29289 12.2934C5.90237 12.6839 5.90237 13.3171 6.29289 13.7076C6.68342 14.0981 7.31658 14.0981 7.70711 13.7076L10 11.4147L12.2929 13.7076C12.6834 14.0981 13.3166 14.0981 13.7071 13.7076C14.0976 13.3171 14.0976 12.6839 13.7071 12.2934L11.4142 10.0005L13.7071 7.70759C14.0976 7.31707 14.0976 6.68391 13.7071 6.29338C13.3166 5.90286 12.6834 5.90286 12.2929 6.29338L10 8.58628L7.70711 6.29338Z",
    fill: "#FFA998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/red-cross.46e4130d7a7efb59ef5938f90064c2da.svg";
export { ForwardRef as ReactComponent };